import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSwitch2 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M14.617 5.112A1.2 1.2 0 0 1 15.6 4.6h7.2a1.2 1.2 0 0 1 0 2.4h-6.575l-1.646 2.352a1.2 1.2 0 0 1-1.966-1.376l2.004-2.864Zm-4.725 8.842a1.2 1.2 0 0 1 .295 1.67l-2.004 2.864A1.2 1.2 0 0 1 7.2 19h-6a1.2 1.2 0 0 1 0-2.4h5.375l1.646-2.351a1.2 1.2 0 0 1 1.671-.295Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M18.352 1.351a1.2 1.2 0 0 1 1.697 0l3.6 3.6a1.2 1.2 0 0 1 0 1.698l-3.6 3.6a1.2 1.2 0 1 1-1.697-1.698l2.75-2.751-2.75-2.751a1.2 1.2 0 0 1 0-1.698ZM0 5.8a1.2 1.2 0 0 1 1.2-1.2h6a1.2 1.2 0 0 1 .983.512L16.225 16.6H22.8a1.2 1.2 0 0 1 0 2.4h-7.2a1.2 1.2 0 0 1-.983-.512L6.575 7H1.2A1.2 1.2 0 0 1 0 5.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M18.352 13.351a1.2 1.2 0 0 1 1.697 0l3.6 3.6a1.2 1.2 0 0 1 0 1.697l-3.6 3.6a1.2 1.2 0 1 1-1.697-1.697l2.75-2.751-2.75-2.752a1.2 1.2 0 0 1 0-1.697Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSwitch2);
export default ForwardRef;
